import { UIParagraphFormat } from '../../../config/formats';
import { FPageColorScheme, FPageBlockWrap, FPageSplitAlign, FPageItemAlign } from '../../mdl/f-page-block';
import { UIValue } from '../../ui/types';
import { EDBackgroundPreset } from '../image';

export namespace $page_values {
    export const bg_presets: Record<string, EDBackgroundPreset> = {
        none: { name: 'None', bg: {} },
        pink: { name: 'Pink', bg: { color: '#FFBBEA' } },
        light_pink: { name: 'Light pink', bg: { color: '#FFF2F8' } },
        red: { name: 'Red', bg: { color: '#95122A' } },
        dark_red: { name: 'Dark red', bg: { color: '#3D0A16' } },
        almost_white: { name: 'Almost white', bg: { color: '#F8F8F8' } },
        white: { name: 'White', bg: { color: '#FFFFFF' } },
        green: { name: 'Green', bg: { color: '#004B3C' } },
        events: { name: 'Event gradient', bg: { gradient: 'linear', stops: [['#95122A'], ['#B91633']] } },
        brand_red: { name: 'Brand red', bg: { color: '#FF696D' } },
    }

    // export const default_formats: UIParagraphFormat[] = ['text', 'bigtitle', 'narrow', 'title', 'subtitle', 'events-title', 'heading', 'info', 'small'];
    export const default_formats: UIParagraphFormat[] = ['text', 'new-bubble', 'new-info', 'new-hero-title', 'new-title', 'new-subtitle', 'new-heading', 'new-subheading'];
    export const hero_formats: UIParagraphFormat[] = ['text', 'hero-title'];

    export const color_scheme: UIValue<FPageColorScheme>[] = [{ key: 'inherit', name: 'Inherit' }, { key: 'light', name: 'Light' }, { key: 'dark', name: 'Dark' }, { key: 'green', name: 'Green' }, { key: 'lgreen', name: 'Light green' }];
    export const block_wrap: UIValue<FPageBlockWrap>[] = [{ key: 'normal', name: 'Normal' }, { key: 'wide', name: 'Wide' }];
    export const split_align: UIValue<FPageSplitAlign>[] = [{ key: 'start', name: 'Start' }, { key: 'center', name: 'Center' }, { key: 'end', name: 'End' }];
    export const item_align: UIValue<FPageItemAlign>[] = [{ key: 'left', name: 'Left' }, { key: 'center', name: 'Center' }, { key: 'right', name: 'Right' }];
}
